/*
  Interfaz de Cocinomía. Dos piezas independientes, sin estado compartido:
  1. Ripple en los botones (se apaga si la persona pidió menos movimiento).
  2. Barra de compra fija del celular: aparece al pasar 1,2 pantallas de scroll.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  document.addEventListener('pointerdown', function (e) {
    var target = e.target;
    var btn = target && target.closest ? target.closest('.cx-buy, .cx-btn') : null;
    if (!btn || btn.disabled) return;

    var r = btn.getBoundingClientRect();
    var size = Math.max(r.width, r.height) * 2.2;
    var dot = document.createElement('span');
    dot.className = 'cx-ripple';
    dot.style.width = dot.style.height = size + 'px';
    dot.style.left = e.clientX - r.left - size / 2 + 'px';
    dot.style.top = e.clientY - r.top - size / 2 + 'px';
    btn.appendChild(dot);
    dot.addEventListener('animationend', function () {
      dot.remove();
    });
  });
})();

(function () {
  'use strict';

  var ratio = 1.2;
  var visible = false;
  var seen = [];
  var io = null;

  function bar() {
    return document.querySelector('[data-cx-buybar]');
  }

  function update() {
    var el = bar();
    if (!el) return;
    var top = window.scrollY || document.documentElement.scrollTop;
    var scroller = document.querySelector('.page-wrapper');
    if (scroller && scroller.scrollTop > top) top = scroller.scrollTop;
    var pasa = top > ratio * window.innerHeight && seen.length === 0;
    if (pasa !== visible) {
      visible = pasa;
      el.classList.toggle('is-on', pasa);
    }
  }

  // Si ya hay un botón de compra a la vista dentro de la página, la barra se esconde: nunca dos a la vez.
  function watch() {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    seen = [];
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = seen.indexOf(en.target);
        if (en.isIntersecting && i < 0) seen.push(en.target);
        if (!en.isIntersecting && i >= 0) seen.splice(i, 1);
      });
      update();
    });
    Array.prototype.forEach.call(document.querySelectorAll('.cx-sec .cx-buy'), function (b) {
      io.observe(b);
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', function () {
    visible = false;
    watch();
    update();
  });
  watch();
  update();
})();

/*
  Home de venta del ebook. Seis piezas, cada una se activa solo si encuentra su elemento:
  1. Palabra que rota en el título [data-cx-rot] (quieta si la persona pidió menos movimiento).
  2. Contador de la oferta [data-cx-timer]: la hora de fin viene del tema y es igual para todos.
  3. Animación al entrar en pantalla [data-cx-inview] (cascada y barras).
  4. Solapas de la proyección [data-cx-tabs]. Sin JavaScript se ven los dos gráficos, uno abajo del otro.
  5. La cuenta de un pedido [data-cx-order]: tocar una parte de la barra la explica.
  6. Capturas del libro [data-cx-shots]: se abren grandes en una ventana.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) {
    Array.prototype.forEach.call(list, fn);
  };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function rotate(scope) {
    if (reduced) return;
    each(scope.querySelectorAll('[data-cx-rot]'), function (el) {
      if (el.getAttribute('data-cx-on')) return;
      el.setAttribute('data-cx-on', '1');
      var words = el.querySelectorAll('.cx-rot__w');
      if (words.length < 2) return;
      var i = 0;
      var id = setInterval(function () {
        if (!document.body.contains(el)) {
          clearInterval(id);
          return;
        }
        if (document.hidden) return;
        words[i].classList.remove('is-on');
        i = (i + 1) % words.length;
        words[i].classList.add('is-on');
      }, 2200);
    });
  }

  function countdown(scope) {
    each(scope.querySelectorAll('[data-cx-timer]'), function (el) {
      if (el.getAttribute('data-cx-on')) return;
      el.setAttribute('data-cx-on', '1');
      var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
      var out = el.querySelector('[data-cx-count]');
      if (!end || !out) return;
      var id;

      function tick() {
        if (!document.body.contains(el)) {
          clearInterval(id);
          return;
        }
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(id);
          el.className += ' is-ended';
          el.textContent = el.getAttribute('data-ended') || '';
          var bar = el.closest ? el.closest('.cx-urgency') : null;
          if (bar) bar.className += ' is-ended';
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        out.textContent = (d > 0 ? d + ' d ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }

      tick();
      id = setInterval(tick, 1000);
    });
  }

  function inview(scope) {
    var items = scope.querySelectorAll('[data-cx-inview]');
    if (!('IntersectionObserver' in window)) {
      each(items, function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.25 }
    );
    each(items, function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  function tabs(scope) {
    each(scope.querySelectorAll('[data-cx-tabs]'), function (box) {
      if (box.getAttribute('data-cx-on')) return;
      box.setAttribute('data-cx-on', '1');
      var tabEls = box.querySelectorAll('[role="tab"]');
      var panels = box.querySelectorAll('[role="tabpanel"]');
      if (!tabEls.length || tabEls.length !== panels.length) return;

      function select(n, focus) {
        each(tabEls, function (t, j) {
          var on = j === n;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        each(panels, function (p, j) {
          p.hidden = j !== n;
        });
      }

      each(tabEls, function (t, j) {
        t.addEventListener('click', function () {
          select(j, false);
        });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
          e.preventDefault();
          var n = j;
          if (k === 'ArrowRight') n = (j + 1) % tabEls.length;
          if (k === 'ArrowLeft') n = (j - 1 + tabEls.length) % tabEls.length;
          if (k === 'Home') n = 0;
          if (k === 'End') n = tabEls.length - 1;
          select(n, true);
        });
      });

      box.classList.add('is-js');
      select(0, false);
    });
  }

  // La cuenta de un pedido: tocar una parte de la barra (o su renglón) la explica y apaga el resto.
  function order(scope) {
    each(scope.querySelectorAll('[data-cx-order]'), function (box) {
      if (box.getAttribute('data-cx-on')) return;
      box.setAttribute('data-cx-on', '1');
      var segs = box.querySelectorAll('.cx-order__seg');
      var items = box.querySelectorAll('.cx-order__item');
      if (!segs.length || segs.length !== items.length) return;

      function select(n, fromBar) {
        var closing = items[n].classList.contains('is-on');
        each(items, function (it, j) {
          var on = j === n && !closing;
          it.classList.toggle('is-on', on);
          segs[j].classList.toggle('is-on', on);
          segs[j].setAttribute('aria-pressed', on ? 'true' : 'false');
          it.querySelector('.cx-order__row').setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        box.classList.toggle('has-sel', !closing);
        if (fromBar && !closing && items[n].scrollIntoView) {
          items[n].scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
        }
      }

      each(segs, function (sg, j) {
        sg.addEventListener('click', function () {
          select(j, true);
        });
      });
      each(items, function (it, j) {
        it.querySelector('.cx-order__row').addEventListener('click', function () {
          select(j, false);
        });
      });
      box.classList.add('is-js');
    });
  }

  // Capturas del libro: al tocar una se abre grande, con flechas para pasar de una a otra.
  function lightbox(scope) {
    each(scope.querySelectorAll('[data-cx-shots]'), function (list) {
      if (list.getAttribute('data-cx-on')) return;
      list.setAttribute('data-cx-on', '1');
      var host = list.closest ? list.closest('section') : null;
      var dlg = (host || document).querySelector('[data-cx-lb]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var img = dlg.querySelector('[data-cx-lb-img]');
      var cap = dlg.querySelector('[data-cx-lb-cap]');
      var links = list.querySelectorAll('[data-cx-shot]');
      var cur = 0;

      function show(n) {
        cur = (n + links.length) % links.length;
        var a = links[cur];
        img.src = a.getAttribute('href');
        img.alt = a.getAttribute('data-alt') || '';
        cap.textContent = a.getAttribute('data-cap') || '';
      }

      each(links, function (a, j) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          show(j);
          dlg.showModal();
        });
      });
      dlg.querySelector('[data-cx-lb-close]').addEventListener('click', function () {
        dlg.close();
      });
      dlg.querySelector('[data-cx-lb-prev]').addEventListener('click', function () {
        show(cur - 1);
      });
      dlg.querySelector('[data-cx-lb-next]').addEventListener('click', function () {
        show(cur + 1);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(cur + 1);
        if (e.key === 'ArrowLeft') show(cur - 1);
      });
    });
  }

  function init(scope) {
    rotate(scope);
    countdown(scope);
    tabs(scope);
    order(scope);
    lightbox(scope);
    inview(scope);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
